"use strict";function uploadImageFromCamera$(a){return ddSdk_1.ddSdk.invokeAPI(apiName,a)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.uploadImageFromCamera$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.uploadImageFromCamera";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.uploadImageFromCamera$=uploadImageFromCamera$,exports.default=uploadImageFromCamera$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/uploadImageFromCamera.js
// module id = 1034
// module chunks = 106